export default __webpack_public_path__ + "media/images/all_logo_fluxod-1e1bed62c8487e7de5ab12f07eff81f9.png";